<template>
  <div class="header-container">
    <el-row>
      <el-col :span="12">
        <div>
         <span class="iconfont icon-shouye homepageIcon"><a class="homPage" @click="toMain"></a></span>
            <div class="header-logo">
            <i  class="router-btn"  @click="_backOff">< </i>
            <i   style=" font-size: 25px;color: #bfbfbf; height: 50px; padding: 1px; cursor: pointer
             border: none;background: none;outline: none" @click="_forWard"> ></i>
          </div>
          <div class="header-center">
          </div>
        </div>
      </el-col>
      <el-col :span="8">
     <div class="user-info">
      <el-dropdown class="user-dropdown">
          <span class="user-avatar">
            <span class="avatar">
                 <img class="avatar-img" :src="avatar" alt="">
              </span>
            <span class="user-name coloc-text">{{userName}}</span>
           <span class="user-down"><i class="el-icon-arrow-down el-icon--right"></i>
           </span>
          </span>
        <el-dropdown-menu slot="dropdown" class="user-dropmenu">
          <el-dropdown-item  @click.native="logout"  class="logOut  menu" style="clear:both;min-width: 32%">退出</el-dropdown-item>
          <el-dropdown-item class="help  menu" style="clear:both;min-width: 32%"  @click.native="help">帮助</el-dropdown-item>
          <el-dropdown-item class="about  menu" style="clear:both;min-width: 32%"  @click.native="about">关于</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      </div>
      </el-col>
    </el-row>
  </div>
</template>

<script type="text/ecmascript-6">
  import logoSrc from '../../../../static/image/bt-logo.png'
  import http from '@/api/http'
  import qs from 'qs'
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  import * as _ from '@/common/js/config'
  import {cookies} from '../../../api/util'
  export default {
    data() {
      return {
        userName:'',
        avatar: '',
        home:`${window.indexURL}`,
        logoSrc,
        loading:false,
      }
    },
    created() {
      this.getUserInfo()
    },
    methods: {
      logout() {
        http.post('/logout.json').then(res => {
          if (res.data.code === _.ERR_OK) {
            window.location.href = `${window.logoutURL}`
            // this.$router.push({path:'/login'})
            cookies.delAllCookie()
          } else {
          }
        }).catch(err => {
        })
      },
     help(){
         let helpUrl = this.$router.resolve({
          path: "/Help",
     });
       window.open(helpUrl.href, '_blank')
     },
     about(){
         let helpUrl = this.$router.resolve({
          path: "/About",
      });
        window.open(helpUrl.href, '_blank')
     },
      toMain() {
      //  this.$router.push({name: 'EntryPage'})
      },
      _backOff() {
        this.$router.go(-1)
         //window.history.go(-1)
      },
      _forWard() {
       this.$router.go(1)
        //window.history.go(1)
      },

      GetToken(name) {
        let search = window.location.href;
        let pattern = new RegExp("[?&]" + name + "\=([^&]+)", "g");
        let matcher = pattern.exec(search);
        let items = null;
        if (null != matcher) {
          try {
            items = decodeURIComponent(decodeURIComponent(matcher[1]));
          } catch (e) {
            try {
              items = decodeURIComponent(matcher[1]);
            } catch (e) {
              items = matcher[1];
            }
          }
        }
        return items;
      },
      getUserInfo() {
        let Token = this.GetToken('token')

        let userInf = cookies.getCookie('eimageglobaltid')
        if(Token != null && Token != undefined) {
          // let TOKEN = qs.stringify({
          //     'Teyangtoken': Token,
          // })
          // let tk =  JSON.stringify(Token)
          // alert(TOKEN)
          this.loading=true;
          http.post('/noPasswordlogin.json', {'Teyangtoken':Token}).then(res => { //查询影像所见和诊断结果
             this.loading=false;
            if (res.data.code == "SUCCESS") {
              cookies.delAllCookie()
              cookies.setCookie('eimageglobaltid', res.data.model.eimageglobaltid)
              this.userName = res.data.model.user.userName
              this.avatar = res.data.model.user.userPhoto
            }else if(res.data.code === _.ERR_ERR_NORIGHT){//免登接口判断用户是否有权限 没有则提示
              this.$message.error(res.data.msg);
              cookies.delAllCookie()
              cookies.setCookie('eimageglobaltid', res.data.model.eimageglobaltid)
              this.userName = res.data.model.user.userName;
              this.avatar = res.data.model.user.userPhoto;
            }
          }).catch(err => {this.loading=false;})
        } else if ( userInf != null) {

           http.post('/getUserInfo.json').then(res => {

            if (res.data.code === _.ERR_OK) {
              this.userName = res.data.model.userName
              let ImgUrl = res.data.model.userPhoto.substring(0,6)
              if(ImgUrl==='doctor'){
                this.avatar = `${window.BASE_URL}${res.data.model.userPhoto}`
              } else {
                this.avatar = `${res.data.model.userPhoto}`
              }
            }
           }).catch(err => {})
        } else {
          http.post('/login.json').then(res => {
              if (res.data.code === _.ERR_OK) {
              }
          }).catch(err => {

          })
        }
      },
      upload() {
        window.location.href="./static/upload/ZheBao_Setup_20180807.exe"
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .fullscreen_11
    position: fixed
    width: 100%
    height: 100%
    top: 0
    left: 0
    z-index: 999
  .systemLogo
    width: 180px
    float left
    height: 50px
    background: #122248
    overflow: hidden
    .logoText
      line-height: 50px
      color: $color-index-text
      font-size: $font-size-medium-x
      float: left
    .logoImg
      width: 30px
      height: 30px
      margin: 10px 13px
      float: left
      border-radius: 50%
  .header-container
    width: 100%
    height: 50px
    float: right
    background: $color-background-d
    position: relative
    z-index: 20
  .parTxt
    margin-right 20px
    width: 144px
    float: right
    height: 26px
    margin-top: 12px
    .unpload
      display: inline-block
      width: 141px
      float: left
      color: #00b2b1
      border: 1px solid #dbe4e6
      line-height: 26px
      text-align: center
      border-radius: 4px
      font-size: 12px
      margin-left: -20px
    .unpload:hover
      border-color: #00b2b1
      color: #00b2b1
  .router-btn
    font-size: 25px
    color: #bfbfbf
    height: 50px
    padding: 1px
    cursor: pointer
    border: none
    background: none
    outline: none
    &:hover
      color: $color-button-hover
  .coloc-text
    color: $color-text
  .tuichu
    position: relative
    top: 2px
  .header-center
      float: left
      height: 50px
      line-height: 50px
      width 310px
      margin: 7px  5px 0 20px
      background: url(../../../../static/image/log.png) no-repeat
  .header-rt
    margin-left: 0px
    width: 310px
    background: url(../../../../static/image/logo.png) no-repeat 0 0;
  .header-logo
    height: 100%
    line-height: 50px
    text-align: center
    font-weight bold
    width: 70px
    margin-left: 10px
    float: left
  .homepageIcon
    width: 50px
    height: 50px
    display block
    float: left
    line-height: 50px !important
    cursor: pointer

    text-align: center
    position: relative
  .homPage
    position absolute
    top: 0
    left: 0
    display: block
    width: 100%
    height: 100%
  .user-info
    float: right
    min-width: 32%
    height: 50px
    line-height: 50px
    margin-left: -16px
    .user-dropmenu
      display: inline-block
      height: 50px
      line-height: 50px
      text-overflow: ellipsis
      overflow: hidden
      white-space: nowrap
      margin-left: 10px
      line-height: 50px
    .user-avatar
      float: right
      height: 50px
    .user-logout, .user-about
      cursor: pointer
      float: right
      width: 80px
      text-align: center
      height: 50px;
      display inline-block
      background: $color-background-d
    .avatar
      display: inline-block
      width: 50px
      height: 50px
      border-radius: 50%
      overflow: hidden
      position: relative
      .avatar-img
        margin-top: 5px
        width: 40px
        height: 40px
        border-radius:50%
        overflow: hidden
    .user-name
      // float: right
      display: inline-block
      height: 50px
      line-height: 50px
      text-overflow: ellipsis
      overflow: hidden
      white-space: nowrap
      margin-left: 10px
    .user-down
      display: inline-block
      height: 50px
      line-height: 50px
      text-overflow: ellipsis
      overflow: hidden
      white-space: nowrap

</style>



// WEBPACK FOOTER //
// helpHead.vue?207ed9fd